import { defineComponent } from '~/scripts/utils/alpine'

export default defineComponent(() => ({
  overlay: false,
  async init() {
    await this.$nextTick()
    this.update()
    this.$watch('$store.ui.scrollY', () => this.update())
  },
  update() {
    this.overlay = this.$store.ui.scrollY >= 10
  },
}))
